import * as React from 'react';
import { flow, head } from 'lodash';
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { IStore } from '../../../../redux/IStore';
import { Form } from 'react-bootstrap';
import { IQuoteActions } from '../../../../services/quote/models';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { ISignposted, ITraveller } from '../../../../data/api/models';
import { HeaderDisplay } from './Components/HeaderDisplay';
import { MedicalSignpost } from './Components/MedicalSignpost';

interface ISignpost extends InjectedFormProps {
  travellers: ITraveller[];
  signposted: ISignposted;
  onBack: () => any;
  actions: {
    quote: IQuoteActions;
  };
}

class Signpost extends React.Component<ISignpost, any> {

  public constructor(props) {
    super(props);
    const { applicationId } = props;
    this.props.actions.quote.addNotes('Medical load over threshold – directory signposted', applicationId);
  }

  public render() {
    const {
      travellers,
      handleSubmit,
    } = this.props;

    const leadTraveller = head(travellers);

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <div className="steps-container signpost" style={{ marginTop: '30px' }}>

          <HeaderDisplay leadTraveller={leadTraveller}/>

          <MedicalSignpost/>

        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const applicationId = selector(state, 'id');
      const travellers = selector(state, 'travellers');
      const signposted = selector(state, 'signposted');
      return {
        auth: state.auth,
        applicationId,
        travellers,
        signposted,
      };
    },
    (dispatch) => ({
      dispatch,
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(Signpost);
